import { ReactNode } from 'react';

interface PublicPageWrapperProps {
  children: ReactNode;
}

export function PublicPageWrapper({ children }: PublicPageWrapperProps) {
  return (
    <div>
      {children}
    </div>
  );
}
